import React from "react";
import { Grid, Button, ButtonGroup, TextField, Box, Typography } from "@mui/material";

const gases = ["NO", "NO2", "NOx", "O2", "SO2", "CO", "CO2"];

const SixtyIForm = ({ settings, sixtyIConfig }) => (
  <Grid container spacing={2} sx={{ p: 2 }}>
    <Grid size={{ xs: 12, md: 3 }}>
      <TextField label="IP Address" value={settings?.ipAddress ?? ""} slotProps={{ input: { readOnly: true } }} fullWidth />
    </Grid>
    <Grid size={{ xs: 12, md: 9 }}>
      <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}>
        <Typography variant="body2">Measurement gas</Typography>
        <ButtonGroup variant="outlined" size="small" sx={{ flexWrap: "wrap", gap: 0.5 }}>
          {gases.map((gas) => {
            const active = sixtyIConfig?.measurements?.find((m) => m.name === gas);
            return (
              <Button key={gas} color={active ? "primary" : "inherit"} variant={active ? "contained" : "outlined"}>
                {gas}
              </Button>
            );
          })}
        </ButtonGroup>
      </Box>
    </Grid>
  </Grid>
);

export default SixtyIForm;
